import { Moment } from 'moment';
import { DecodedValueMap, QueryParamConfigMap } from 'common/hooks/customSearchParams';
import { isToday, isYesterday, parseDateRange } from './common';

export enum GatedInFilterKind {
  Today = 'today',
  Yesterday = 'yesterday',
  DateRange = 'dateRange',
}

export interface GatedInDateRange {
  kind: GatedInFilterKind.DateRange;
  startDate: Moment | null;
  endDate: Moment | null;
}

export interface GatedInToday {
  kind: GatedInFilterKind.Today;
}

export interface GatedInYesterday {
  kind: GatedInFilterKind.Yesterday;
}

export type GatedInFilter = GatedInDateRange | GatedInToday | GatedInYesterday;

/**
 * Return the gated out filters based on the search params
 * This consolidates various spread out code
 * @param searchParams the search params to parse gated out filters from
 * @returns a list of gated out filters
 */
export const getGatedInFilters = (
  searchParams: Partial<DecodedValueMap<QueryParamConfigMap>>
): GatedInFilter[] => {
  const filters: GatedInFilter[] = [];

  const { gatedInAt } = searchParams;

  if (!gatedInAt) {
    return filters;
  }

  if (isToday(gatedInAt)) {
    filters.push({ kind: GatedInFilterKind.Today });
  }

  if (isYesterday(gatedInAt)) {
    filters.push({ kind: GatedInFilterKind.Yesterday });
  }

  {
    const results = parseDateRange(gatedInAt);
    if (results) {
      filters.push({ kind: GatedInFilterKind.DateRange, ...results });
    }
  }

  return filters;
};
